module.exports = __webpack_public_path__ + "static/media/tick.69d6e459.svg";